<template>
	<q-layout-drawer side="right" v-model="showMenu" v-if="$q.platform.is.mobile">
		<q-list no-border link inset-separator>
			<q-list-header>{{ $t('idioms') }}</q-list-header>

			<q-item
				v-for="(language, index) in languages"
				:key="index"
				@click.native="changeIdiom(language.id)"
			>
				<q-item-side>
					<flag :iso="language.country_flag" :squared="false" />
				</q-item-side>
				<q-item-main :label="language.name" />
			</q-item>
		</q-list>

		<q-list no-border link inset-separator>
			<q-list-header>{{ $t('questions') }}</q-list-header>

			<q-item v-for="(question, index) in questions" :to="{ name: question.to }" :key="index">
				<q-item-side>
					<q-icon name="far fa-question-circle" />
				</q-item-side>
				<q-item-main :label="$t(question.name)" />
			</q-item>
		</q-list>

		<q-list no-border link inset-separator>
			<q-list-header>{{ $t('institutional') }}</q-list-header>

			<q-item v-for="(inst, index) in institutional" :to="{ name: inst.to }" :key="index">
				<q-item-side>
					<q-icon name="far fa-building" />
				</q-item-side>
				<q-item-main :label="$t(inst.name)" />
			</q-item>
		</q-list>

		<div class="row  gutter-xs flex justify-center q-mx-md">
			<!-- Portugues -->
			<div class="col-6" v-if="urlStoreGoogle && id_user_language_selected == 1">
				<a :href="urlStoreGoogle">
					<img src="~assets/store_icons/google_portugues.png" style="width: 100%" />
				</a>
			</div>

			<div class="col-6" v-if="useAppleCodes && id_user_language_selected == 1">
				<a href="#" @click.prevent="open_modal()" style="cursor: pointer;">
					<img src="~assets/store_icons/app_portugues.png" style="width: 100%" />
				</a>
			</div>

			<div class="col-6" v-else-if="urlStoreApple && id_user_language_selected == 1">
				<a :href="urlStoreApple" target="_blank">
					<img src="~assets/store_icons/app_portugues.png" style="width: 100%" />
				</a>
			</div>

			<!-- English -->
			<div class="col-6" v-if="urlStoreGoogle && id_user_language_selected == 2">
				<a :href="urlStoreGoogle">
					<img src="~assets/store_icons/google_ingles.png" style="width: 100%" />
				</a>
			</div>

			<div class="col-6" v-if="useAppleCodes && id_user_language_selected == 2">
				<a href="#" @click.prevent="open_modal()" style="cursor: pointer;">
					<img src="~assets/store_icons/app_ingles.png" style="width: 100%" />
				</a>
			</div>

			<div class="col-6" v-else-if="urlStoreApple && id_user_language_selected == 2">
				<a :href="urlStoreApple" target="_blank">
					<img src="~assets/store_icons/app_ingles.png" style="width: 100%" />
				</a>
			</div>

			<!-- Español -->
			<div class="col-6" v-if="urlStoreGoogle && id_user_language_selected == 3">
				<a :href="urlStoreGoogle">
					<img src="~assets/store_icons/google_espanhol.png" style="width: 100%" />
				</a>
			</div>

			<div class="col-6" v-if="useAppleCodes && id_user_language_selected == 3">
				<a href="#" @click.prevent="open_modal()" style="cursor: pointer;">
					<img src="~assets/store_icons/app_espanhol.png" style="width: 100%" />
				</a>
			</div>

			<div class="col-6" v-else-if="urlStoreApple && id_user_language_selected == 3">
				<a :href="urlStoreApple" target="_blank">
					<img src="~assets/store_icons/app_espanhol.png" style="width: 100%" />
				</a>
			</div>

			<!-- Fraçais -->
			<div class="col-6" v-if="urlStoreGoogle && id_user_language_selected == 4">
				<a :href="urlStoreGoogle">
					<img src="~assets/store_icons/google_frances.png" style="width: 100%" />
				</a>
			</div>

			<div
				class="col-6"
				v-if="register_fields.use_apple_code && id_user_language_selected == 4"
			>
				<a href="#" @click.prevent="open_modal()" style="cursor: pointer;">
					<img src="~assets/store_icons/app_frances.png" style="width: 100%" />
				</a>
			</div>

			<div class="col-6" v-else-if="urlStoreApple && id_user_language_selected == 4">
				<a :href="urlStoreApple" target="_blank">
					<img src="~assets/store_icons/app_frances.png" style="width: 100%" />
				</a>
			</div>
		</div>

		<q-modal
			v-model="show_modal"
			:content-css="{ minWidth: '80vw', maxWidth: '100vw', minHeight: '90vh' }"
			@hide="show_modal = false"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_modal = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('download_app') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="codes"
						:columns="columns"
						@request="listCodes"
						:loading="loading"
						row-key="code"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
					>
						<template slot="top" slot-scope="props">
							<div class="col" />
							<q-btn
								color="primary"
								icon="fas fa-plus"
								@click="generateCode()"
								:label="$t('new_download_code')"
								:disable="disable_new_code"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td key="redemption_link" :props="props">
								<q-btn
									flat
									icon="fas fa-download"
									color="primary"
									@click="openLink(getlink(props.row.redemption_link))"
								/>
							</q-td>

							<q-td key="code" :props="props">
								{{ props.row.code }}
							</q-td>

							<q-td key="created_date" :props="props">
								{{ fDate(props.row.created_date) }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-layout-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'authenticated'] },

	data() {
		return {
			questions: [{ name: 'frequent_questions', to: 'faq' }, { name: 'help', to: 'help' }],
			institutional: [
				{ name: 'about_the_company', to: 'institutional-about' },
				{ name: 'privacy_policy', to: 'institutional-privacy' },
				{ name: 'terms_conditions', to: 'institutional-terms' },
			],
			show_modal: false,
			loading: false,
			codes: [],
			columns: [
				{
					name: 'redemption_link',
					required: true,
					label: 'download',
					align: 'left',
					field: 'redemption_link',
					sortable: false,
				},
				{
					name: 'code',
					required: true,
					label: 'redemption_code',
					align: 'left',
					field: 'code',
					sortable: false,
				},
				{
					name: 'created_date',
					required: true,
					label: 'creation_date',
					align: 'left',
					field: 'created_date',
					sortable: false,
				},
			],
			disable_new_code: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			languages: 'params/languages',
			register_fields: 'params/register_fields',
			right_menu: 'common/right_menu',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		showMenu: {
			get() {
				return this.right_menu
			},
			set() {
				this.$store.dispatch('common/SET_RIGHT_MENU', [false])
			},
		},

		urlStoreGoogle() {
			if (this.$q.platform.is.cordova) {
				return ''
			} else if (this.$q.platform.is.desktop) {
				if (process.env.CORDOVA_ID != 'null')
					return `https://play.google.com/store/apps/details?id=${process.env.CORDOVA_ID}`
				else return ''
			} else {
				if (process.env.APP_URL_GOOGLE != 'null' && process.env.APP_URL_GOOGLE != '')
					return process.env.APP_URL_GOOGLE
				else return ''
			}
		},

		urlStoreApple() {
			if (process.env.APP_URL_APPLE != 'null' && process.env.APP_URL_APPLE != '')
				return process.env.APP_URL_APPLE
			else return ''
		},

		useAppleCodes() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) return obj.use_apple_code
			}
			return false
		},
	},

	methods: {
		changeIdiom(code) {
			this.$store.dispatch('common/SET_LANGUAGE', [code])
			this.setUserSelection()
		},

		setUserSelection() {
			this.$q.loading.show()

			let fd = new FormData()
			fd.append('client', this.id_user_client_selected)
			fd.append('country', this.id_user_client_country_selected)
			fd.append('language', this.id_user_language_selected)

			this.$axios
				.post('/accounts/set_user_selection/', fd, this.getHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
					])
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		open_modal() {
			this.show_modal = true
			this.disable_new_code = false
			this.listCodes()
		},

		listCodes() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_import/codes_app/list_user_code/`, this.getHeader)
				.then((response) => {
					this.codes = response.data.map((e) => {
						return {
							...e,
							code: e.code,
							redemption_link: e.code,
						}
					})

					this.codes.reverse()
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					if (this.codes.length === 0) this.generateCode()
					else this.$q.loading.hide()
				})
		},

		generateCode() {
			this.$q.loading.show()

			this.$axios
				.post(`/admin_import/apple_code/`, {}, this.getHeader)
				.then((response) => {
					let e = response.data
					this.disable_new_code = true

					if (e) {
						this.codes.unshift({
							...e,
							code: e.code,
							redemption_link: e.code,
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		getlink(code) {
			return `https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/freeProductCodeWizard?code=${code}`
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		downloadApp() {
			window.location = urlStoreApple
		},

		openLink(link) {
			if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
				cordova.InAppBrowser.open(
					link,
					'_system',
					'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no'
				)
			} else {
				window.open(link, '_blank')
			}
		},
	},

	watch: {
		id_user_language_selected: function(val) {
			let language = this.languages.find((l) => {
				return l.id === this.id_user_language_selected
			})

			if (language) this.$i18n.i18next.changeLanguage(language.code.split('-')[0])
		},
	},
}
</script>

<style lang="stylus" scoped>
.redemption-link
    color #000000
</style>
